import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { VoucherCouponService } from 'app/services/voucher-coupon-mg/voucher-coupon.service';
import { KontableNewComponent } from './../../../../modules/UIKit/components/kontablenew/kontablenew.component';
import { Use } from './../../../../models/voucherCouponMg.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-use',
  templateUrl: './use.component.html',
  styleUrls: ['./use.component.css']
})
export class UseComponent implements OnInit {
  @Input() couponVoucherId: string;  

  paginationType_Use = KontableNewComponent.ServerPagination;
  paginationType_Confirm = KontableNewComponent.ServerPagination;  
  paginationType_Cancel = KontableNewComponent.ServerPagination;  

  currentIndexTab = 0;  

  currentUse: Use;
  
  shownTabs = {
    confirm: false,
    cancel: false,   
    total: 0
  }

  show = {
    use: false,    
    modal: false,
    confirm: false,
    cancel: false
  }

  translations: any;

  initialFilters = {
    use: new Array<{key: string, value: any}>(),
    confirm: new Array<{key: string, value: any}>(),
    cancel: new Array<{key: string, value: any}>()
  }

  methodsNames = {
    use: { list: 'getUse', sendExtSearchQuery: 'sendExtSearchQuery' },
    confirm: { list: 'getUse_Confirm', sendExtSearchQuery: 'sendExtSearchQuery' },
    cancel: { list: 'getUse_Cancel', sendExtSearchQuery: 'sendExtSearchQuery' }
  }

  constructor(
    private srvVoucherCoupon: VoucherCouponService,
    private srvMessage: MessageService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit() {
    this.getPermissionTabs();
    this.getTranslations();
    this.initialFilters.use.push({key: "voucherId", value: this.couponVoucherId});     
    this.currentIndexTab = 0;
    this.show.use = true;
  }  
  getTranslations(){
    var self = this;
    this.srvTranslate.get(["voucherCouponsMg.dt_use_nodata_title","voucherCouponsMg.dt_use_nodata_message"]).subscribe((res) => {      
      self.translations = res;
    });
  }
  onChangeTab(eventChangeTab){    
    this.currentIndexTab = eventChangeTab.index;
    
    if(this.currentIndexTab == 0){
      this.show.confirm = true;
    }
    else if(this.currentIndexTab == 1){
      this.show.cancel = true;
    }    
  }  
  getPermissionTabs(){    
    //può essere integrato con un servizio che decide quali e quanti tab da visualizzare    
    this.shownTabs.confirm = true;
    this.shownTabs.cancel = true;
    this.shownTabs.total = 2;
  }   
  getDateTime(dateTime:string): string{
    let res = "";
    if(dateTime && dateTime.length > 0){
      res = dateTime.substr(8,2) + "/" + dateTime.substr(5,2) + "/" + dateTime.substr(0,4) + " " + dateTime.substr(11,8);
    }
    return res;
  }  
  info(event: Use){
    if(event.operationId){
      this.currentUse = event;
      this.initialFilters.confirm.push({key: "voucherId", value: this.couponVoucherId});
      this.initialFilters.confirm.push({key: "operationId", value: event.operationId});
      this.initialFilters.cancel.push({key: "voucherId", value: this.couponVoucherId});
      this.initialFilters.cancel.push({key: "operationId", value: event.operationId});
      this.show.modal = true;
      this.currentIndexTab == 0;
      this.show.confirm = true;
    }
    else{
      this.srvMessage.add({severity: 'info', summary: this.translations ? this.translations["voucherCouponsMg.dt_use_nodata_title"] : "No Data", detail: this.translations ? this.translations["voucherCouponsMg.dt_use_nodata_message"] : "No Data"});
    }    
  }

}



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/use/use.component.ts